// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    const carousel = document.querySelector(".carousel-hero-caption");
    if (!carousel) return;

    const carouselTrack = carousel.querySelector(":scope > .wp-block-group");
    const carouselSlides = carouselTrack?.querySelector(":scope > .wp-block-group");
    if (!carouselTrack || !carouselSlides) return;

    const originalSlides = Array.from(carouselSlides.children).filter(
        (item) =>
            item.classList &&
            item.classList.contains("wp-block-cover") &&
            !item.classList.contains("glide__slide--clone")
    );

    // Single-slide fallback: skip Glide and keep static hero to avoid clones/flicker.
    if (originalSlides.length <= 1) {
      carousel.classList.add("carousel-hero-caption--single");
      this.resetToStatic(carouselTrack, carouselSlides);
      return;
    }

    // Add Glide classes
    carouselTrack.classList.add("glide__track");
    carouselTrack.dataset.glideEl = "track";
    carouselSlides.classList.add("glide__slides");
    originalSlides.forEach((item) => {
      item.classList.add("glide__slide");
    });

    // Tweak styles
    carousel.style.overflow = "hidden";
    carouselSlides.style.flexWrap = "nowrap";

    new Glide(carousel, {
      type: "carousel",
      perView: 1,
      autoplay: 4000,
      peek: 0,
      gap: 0,
    }).mount();
  }

  resetToStatic(carouselTrack, carouselSlides) {
    carouselTrack.classList.remove("glide__track");
    carouselTrack.removeAttribute("data-glide-el");
    carouselSlides.classList.remove("glide__slides");

    // Remove clone slides in case markup was previously initialized.
    carouselSlides.querySelectorAll(".glide__slide--clone").forEach((clone) => clone.remove());

    // Remove inline slider styles that can break static layout.
    carouselSlides.style.width = "";
    carouselSlides.style.transform = "";
    carouselSlides.style.transition = "";
    carouselSlides.style.flexWrap = "";

    carouselSlides.querySelectorAll(".wp-block-cover").forEach((slide) => {
      slide.classList.remove("glide__slide");
      slide.style.width = "";
      slide.style.marginLeft = "";
      slide.style.marginRight = "";
    });
  }
}

export default CarouselHeroCaption;
